import type { Filters } from 'hooks/store/scheduled-restricted-products-data-imports/use-scheduled-data-imports-search-params';
import type { FormSchema } from './form-schema';

export const createFilterParams = (formData: FormSchema): Filters => {
  return { ...formData };
};
